import React from "react";
import api, { AppTreeDTO, AppUserMemory } from "api";
import { Icon } from "antd";
import { appTree } from "utils";
import {IAppTreeDTO,ProjectTreeTable} from './ProjectTreeTable'
import './index.less'


export interface AppTreeProps {
	scene: number;
    expandLevel?:number;
    searchType?:string;
	onChange?: (data: IAppTreeDTO) => void;
}

export  class AppProjectTree extends React.Component<AppTreeProps> {
	state = {
		treeData: [] as IAppTreeDTO[],
		value: {} as IAppTreeDTO,
        userMemory: {} as AppUserMemory,
        expandLevel:this.props.expandLevel || 3
	};

	// 组织架构树形控件的数据类型为10000
	async componentDidMount() {
        let scene = this.props.scene || 10000;
        let treeData: IAppTreeDTO[] = await api.public.component.getAppTreeList({scene});
		let userMemory = await api.public.component.getValue({scene});
		let value = {} as IAppTreeDTO;
		if (userMemory.dataValue && userMemory.dataValue !== null ) {
			value = treeData.find(e => e.id === userMemory.dataValue) || { fullName: "" } ;
			if (value.fullName !== '') {
				this.props.onChange && this.props.onChange(value);
			} 
		}
		this.setState({ treeData, userMemory, value });
    }

    // componentWillUnmount (){
    //     document.onclick = null;
    // }

    addEvent = () =>{
        document.onclick = () =>{
            let arr = document.querySelectorAll('.project-tree-content')
            for(let i=0 ; i< arr.length;i++){
                let div:any = arr[i];
                div.style.display = 'none';
            }
            document.onclick = null;
        }
    }

    handleSelect = () =>{
        if(this.refTextDiv.current){
            let width = this.refTextDiv.current.offsetWidth;
            let container = this.refTextDiv.current.parentElement;
            let content:any = container.querySelector('.project-tree-content');
            let display = content.style.display==='none'?'inherit':'none';
            content.style.width = `${width}px`
            content.style.display = display;
            this.addEvent()
        }
    }

    refTextDiv = React.createRef<HTMLDivElement>();

	render() {
        let {value,treeData} = this.state
		return (
			<div className="app-project-tree-container" onClick={stopBubbling}>
				<div className="project-tree-text" ref = {this.refTextDiv}
					onClick={() => this.handleSelect()}>
					<span className='full-name-span'>{value.fullName}</span>
					<span className="project-tree-down-icon">
						<Icon type="down" />
					</span>
				</div>
				<div className="project-tree-content"  style={{display:'none' }}>
					{
                        treeData.length===0 ?< React.Fragment/>:
                        <ProjectTreeTable 
                            {...this.state}
                            onChange = {this.props.onChange}
                        />
                    }
				</div>
			</div>
		);
	}
}

const handleTreeData = (treeData: IAppTreeDTO[], expandLevel: number) =>{
    let newTreeData : IAppTreeDTO[] = appTree.list(treeData)
    return newTreeData.map((data: IAppTreeDTO, index:number) => {
        return {...data,
            _table_hidden:data._tree_level > expandLevel,
            _table_indeterminate :false,
            _table_expand_icon:data._tree_level < expandLevel ? 'caret-down' : 'caret-right'
        };
    })
}

const stopBubbling = (e: any) => {
    e.nativeEvent.stopImmediatePropagation()
    e.stopPropagation()
    return false;
}







// WEBPACK FOOTER //
// ./src/qcc/AppProjectTree/index.tsx